import { Component, OnInit, EventEmitter, Output, Input, OnDestroy } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { environment } from 'src/environments/environment';
import { Subscription } from 'rxjs';
import { DataService } from '../../../services/data.service';

@Component({
  selector: 'app-side-menu',
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.less']
})
export class SideMenuComponent implements OnInit, OnDestroy {
  @Input() isShowMenu: boolean = false;
  @Output() closeMenu = new EventEmitter();
  currentApplicationVersion = environment.appVersion;
  private subscription: Subscription;
  currentCompany: any = null
  currentCompanyId: any = null

  constructor(public authService: AuthService, private dataService: DataService,) {
    // if (localStorage.getItem('currentCompany')) {
    //       let company = JSON.parse(localStorage.getItem('currentCompany'));
    //       this.currentCompany = company.name
    //     }
    this.subscription = this.dataService.sharedCompany$.subscribe(company => {
      if(company){
        this.currentCompany = company.name ? company.name: company;
      }else{
        this.currentCompany = company;
      }
    })

    this.subscription = this.dataService.sharedCompanyId$.subscribe(companyId => {
      this.currentCompanyId = companyId;
    })
   }

  ngOnInit(): void {
  }

  resetCompany(){
    this.dataService.updateCompany(null)
    this.dataService.updateCompanyId(null)
    // this.currentCompany = null
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  exitClientMenu(){
    // if(this.currentCompany){
    //   this.resetCompany()
    // }


  }

}
